<template>
  <div ref="toInSearchBody" class="toInSearch">
    <div class="contenter">
      <div class="backgroundImg">
        <img src="@/assets/images/background.png" alt="">
      </div>
      <div class="in-contenter">
        <div class="title">
          <div>{{siteCode === 'gss' ? '价格信息查询' : '信息价查询'}}</div>
        </div>
        <div class="form-search">
          <div v-if="siteCode==='gss'" >
            <a-row style="margin-top:36px">
              <!-- <a-col :span="4"> 编码/名称/规格型号: </a-col> -->
              <a-col :span="20">
                <a-input v-model="materialParam" placeholder="请输入材料编码、名称、规格型号" style="width: 560px" />
              </a-col>
            </a-row>
            <a-row style="margin-top:16px">
              <!-- <a-col :span="4"> 地区: </a-col> -->
              <a-col :span="20">
                <el-cascader
                  style="width: 560px"
                  size="small"
                  v-model="aeraValueListTotal"
                  :options="cityOptions"
                  :props="{ multiple: true, checkStrictly: true, value:'id',label:'name'}"
                  clearable
                  @change="aeraChange">
                </el-cascader>
              </a-col>
            </a-row>
            <a-row style="margin-top:16px">
              <!-- <a-col :span="4"> 信息价时间: </a-col> -->
              <a-col :span="20">
                <a-select placeholder="请选择" v-model="yearValue" style="width: 106px" allowClear @change="yearChange()">
                  <a-select-option v-for="(item,index) in yearList" :key="index" :value="item">{{item}}</a-select-option>
                </a-select>
                <a-select  placeholder="请选择" v-model="numberValue" style="width: 106px;margin-left:10px" allowClear>
                  <a-select-option v-for="(item,index) in numberList" :key="index" :value="item">{{`第${item}期`}}</a-select-option>
                </a-select>
                <span class="separator">至</span>
                <a-select  placeholder="请选择" v-model="yearFValue" style="width: 106px" allowClear @change="yearChange('SC')">
                  <a-select-option v-for="(item,index) in yearList" :key="index" :value="item">{{item}}</a-select-option>
                </a-select>
                <a-select  placeholder="请选择" v-model="numberFValue" style="width: 106px;margin-left:10px" allowClear>
                  <a-select-option v-for="(item,index) in numberFList" :key="index" :value="item">{{`第${item}期`}}</a-select-option>
                </a-select>
                <a-button style="margin-left:10px" icon="search" @click="searchTableFn"> 
                  查询 
                </a-button>
              </a-col>

            </a-row>
          </div>
          <div v-else>
            <ul class="bannerTag">
              <li :class="[activeIndex===index?'is-active':'']" v-for="(item,index) in cityList" :key="item.areaCode" @click="tagclick(item,index)">{{item.areaName}}</li>
            </ul>
            <div class="margin-top16">
              <a-select placeholder="请选择" v-model="yearValue" style="width: 272px" allowClear @change="yearChange()">
                <a-select-option v-for="(item,index) in yearList" :key="index" :value="item">{{item}}</a-select-option>
              </a-select>
              <a-select placeholder="请选择" v-model="numberValue" style="width: 272px;margin-left:16px" allowClear @change="numberChange">
                <a-select-option v-for="(item,index) in numberList" :key="index" :value="item">{{`第${item}期`}}</a-select-option>
              </a-select>
              <a v-if="siteCode==='lcs'" target="_blank" style="margin-left:16px" class="link link--default is-underline">
                <img src="@/assets/images/link.png" alt="">
                <span class="link--inner" @click="getOldData()">查看历史数据</span>
              </a>
            </div>
            <div class="margin-top16">
              <a-input-search v-model="materialParam" placeholder="请输入材料编码、名称、规格型号" style="width: 560px" @search="searchTableFn" />
            </div>
          </div>
        </div>
        <div style="" class="bottom">
          <div id="left" :style="{ width: detailWidth + 'px' }">
            <div style="">
              <span style="" class="menuTitle">材料分类</span>
            </div>
            <a-spin :spinning="spinning">
              <martial-tree
                v-if="gData.length>0"
                :treeData="gData"
                @getTreeNode="getTreeNode"
              >
              </martial-tree>
            </a-spin>
            
          </div>
          <div id="resize">
            <span >|||</span>
          </div>
          <div id="right">
            <div class="tabsList" v-if="detailInfo.length>0">
              <a-collapse v-model="activeKey">
                <a-collapse-panel header="本期说明" key="1">
                  <a-tabs class="cityTabs" :default-active-key="defaultActiveKeyCity" @change="callbackCity">
                    <a-tab-pane :key="item.areaName" :tab="item.areaName" v-for="(item) in detailInfo"> </a-tab-pane>
                  </a-tabs>
                  <a-tabs class="dateTabs" :default-active-key="defaultActiveKeyData" @change="callbackData">
                    <a-tab-pane :key="item.noticeName" :tab="item.noticeName" v-for="(item) in detailDataList"> </a-tab-pane>
                  </a-tabs>
                  <div class="tabContent">
                    <div v-if="detailDataList" class="tabContentIneer">
                      <a-row v-if="detailContain" type="flex">
                        <a-col style="width:70px">本期说明：</a-col>
                        <a-col style="flex: 1 ">{{detailContain}}</a-col>
                      </a-row>
                      <a-row v-if="previousError" type="flex">
                        <a-col style="width:70px">上期勘误：</a-col>
                        <a-col style="flex: 1 ">{{previousError}}</a-col>
                      </a-row>
                      <a-row v-if="sectionExplains" type="flex">
                        <a-col style="width:70px">本节说明：</a-col>
                        <a-col style="flex: 1 ">{{sectionExplains}}</a-col>
                      </a-row>
                    </div>
                    <div v-else class="tabContentIneer">
                      <a-list style="margin:0" :data-source="[]" />
                    </div>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
            <div class="table">
              <a-table
                style="margin-top:24px;min-width:1300px"
                size="small"
                :pagination="false"
                :rowKey="(record,index)=> index"
                :dataSource="tableData"
                :loading="loading"
                bordered
              >
              <a-table-column title="序号" data-index="index" key="index" :customRender="(text,record,index)=>`${index+1}`" width="50px"/>
                <a-table-column title="趋势图" data-index="compareLine" key="compareLine" width="80px">
                  <template slot-scope="text, record">
                    <span class="slot" @click="getLine(record)"> <a-icon type="line-chart" /> </span>
                  </template>
                </a-table-column>
                <a-table-column title="柱状图" data-index="compareBar" key="compareBar" width="80px">
                  <template slot-scope="text, record">
                    <span class="slot" @click="getBar(record)"> <a-icon type="bar-chart" /> </span>
                  </template>
                </a-table-column>
                <a-table-column title="编码" data-index="code" key="code" width="160px"/>
                <a-table-column title="名称" data-index="name" key="name" />
                <a-table-column title="规格型号" data-index="standards" key="standards"/>
                <a-table-column title="单位" data-index="unitDesc" key="unitDesc" width="80px"/>
                <a-table-column v-if="infoPriceReleaseType!='1'" title="含税价格（元）" data-index="includesTaxPricesStr" key="includesTaxPricesStr" width="120px"/>
                <a-table-column v-if="infoPriceReleaseType!='0'" title="除税价格（元）" data-index="excludingTaxPricesStr" key="excludingTaxPricesStr" width="120px"/>
                <a-table-column title="产地" data-index="producingArea" key="producingArea" ellipsis/>
                <a-table-column v-if="siteCode==='gss'" title="信息价名称" data-index="infoName" key="infoName" ellipsis />
                <a-table-column title="备注" data-index="remark" key="remark"  ellipsis />
                <a-table-column title="发布日期" data-index="createAt" key="createAt" width="150px"/>
              </a-table>
              <a-pagination
                style="margin-top:16px"
                v-model="page.pageNum"
                :total="page.total"
                :page-size-options="['10', '20', '30', '40', '50','100']"
                show-size-changer
                :show-total="total => `共 ${page.total} 条`"
                show-quick-jumper
                :page-size.sync="page.pageSize"
                @showSizeChange="onShowSizeChange"
                @change="onShowSizeChange"
              >
              </a-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
    @import "./style.less";
</style>
<style lang="less">
.el-cascader-node.in-active-path,.el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  color:#333;
}
.el-cascader-node:not(.is-disabled):hover{
  background:rgb(230, 247, 255); 
}
</style>

<script>
    /* global module:false */
    /* global require:false */
    module.exports = require("./index.js")
</script>

